// extracted by mini-css-extract-plugin
module.exports = {"CVMain":"CVMainPage_CVMain__1MeVg"};